import PersonalizerApi from "@/services/personalizer_api";
import {
  RETRIEVE_GPT_CONVERSATION_DETAIL,
  RETRIEVE_GPT_PROFILES,
  RETRIEVE_GPT_CONVERSATION_SUMMARY,
  RETRIEVE_CONVERSATION_HISTORY,
  GENERATE_MASKED_TRANSCRIPTION,
  UPDATE_MASKED_CONVERSATION
} from "@/store/_actiontypes";
import { 
  SET_GPT_CONVERSATION_DETAILS,
  SET_GPT_PROFILES,
  SET_GPT_CONVERSATION_SUMMARY,
  SET_CONVERSATION_HISTORY,
  SET_GENERATED_MASKED_TRANSCRIPTION,
  SET_MASKED_CONVERSATION
 } from "@/store/_mutationtypes";

const state = {
  gpt_conversation_details: {},
  gpt_profiles: [],
  conversation_summary: {},
  conversation_history: [],
  genarated_masked_transcription:{}
};

const actions = {
  [RETRIEVE_GPT_CONVERSATION_DETAIL](
    { commit },
    {
      conversation_id,
    },
  ) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.get(`gpt/conversations/${conversation_id}`).then(
        response => {
          const conversation = response.data.detail.response;
          commit(SET_GPT_CONVERSATION_DETAILS, conversation);
          resolve(conversation);
        },
        error => {
          reject(error);
        },
      );
    });
  },
  [RETRIEVE_GPT_PROFILES]({ commit }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.get("gpt/profiles?start=0&size=100").then(
        response => {
          const profiles = response.data.detail.response.profiles;
          commit(SET_GPT_PROFILES, profiles);
          resolve(profiles);
        },
        error => {
          reject(error);
        },
      );
    });
  },
  [RETRIEVE_GPT_CONVERSATION_SUMMARY]({ commit }, {data}) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.post("maira/ask", data).then(
        response => {
          const summary_response = response.data.detail;
          commit(SET_GPT_CONVERSATION_SUMMARY, summary_response);
          resolve(summary_response);
        },
        error => {
          reject(error);
        },
      );
    });
  },
    [GENERATE_MASKED_TRANSCRIPTION]({ commit }, {data}) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.post("maira/ask", data).then(
        response => {
          const masked_response = response.data.detail;
          commit(SET_GENERATED_MASKED_TRANSCRIPTION, masked_response);
          resolve(masked_response);
        },
        error => {
          reject(error);
        },
      );
    });
  },
    [UPDATE_MASKED_CONVERSATION]({ commit }, {conversation_id,masked_response}) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.put(`gpt/conversations/${conversation_id}`, {masked_response:masked_response}).then(
        response => {
          const masked_response_data = response.data.detail;
          commit(SET_MASKED_CONVERSATION, masked_response_data);
          resolve(masked_response_data);
        },
        error => {
          reject(error);
        },
      );
    });
  },
  [RETRIEVE_CONVERSATION_HISTORY]({ commit }, {session_id}) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.post("gpt/conversations", {
        query: {
          filters: {
            request_body: {
              session_id: session_id,
            },
          },
        },
        start: 0,
        size: 200,
      }).then(
        response => {
          const history_response = response.data.detail.response;
          commit(SET_CONVERSATION_HISTORY, history_response);
          resolve(history_response);
        },
        error => {
          reject(error);
        },
      );
    });
  },
};

const mutations = {
  [SET_GPT_CONVERSATION_DETAILS](state, data) {
    state.gpt_conversation_details = data;
  },
  [SET_GPT_PROFILES](state, data) {
    state.gpt_profiles = data;
  },
  [SET_GPT_CONVERSATION_SUMMARY](state, data) {
    state.conversation_summary = data;
  },
  [SET_GENERATED_MASKED_TRANSCRIPTION](state, data) {
    state.masked_audio_text = data;
  },
  [SET_CONVERSATION_HISTORY](state, data) {
    state.conversation_history = data;
  },
};

export const gpt = {
  namespaced: true,
  state,
  actions,
  mutations,
};
